import React, { Children, Component } from "react";
import Navigation from "../../components/Navigation";
import { getObjectUseCase, upsertUseCase } from "../../usecases/object";
import JobDescriptionPresenter from "./JobDescriptionPresenter";
import withRouter from "../../withRouter";
import BaseFormPage from "../../base/BaseFormPage";
import moment from "moment";

class JobDescription extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      object: {},
      advanced: false,
      progress: false,
      quantity: 1,
    };
    this.presenter = new JobDescriptionPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      getObjectUseCase()
    );
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  getCollectionName() {
    return this.props.params.collectionname;
  }
  getSelectedItems() {
    return this.state.selected;
  }
  onclickApplyNow() {
    this.presenter.onClickApplyNow();
  }
  goBack() {
    return window.history.back();
  }

  logout() {
    this.presenter.onClickSignOut();
  }

  render() {
    const object = this.state.object;
    const objectId = this.getObjectId();
    return (
      <>
        <Navigation logout={this.logout.bind(this)} />
        <div style={{ marginTop: `3rem` }} className="p-5">
          <div className="bg-white p-4 rounded-3">
            <div className="d-flex flex-column py-2">
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-3">
                  <div className="d-flex gap-3">
                    <p
                      className="cursor-pointer"
                      onClick={this.goBack.bind(this)}
                    >
                      <i
                        className="bi bi-arrow-left fs-4"
                        style={{ color: `#303030CC` }}
                      ></i>
                    </p>

                    <div className="d-flex flex-column">
                      <h3 className="fw-bold fs-4" style={{ color: `#256F22` }}>
                        {object?.positionTitle}
                      </h3>
                      <p style={{ color: `#30303080` }}>
                        Posted{" "}
                        {object?.created
                          ? `${moment(object?.created).fromNow()}`
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>

                <button
                  className="rounded-2 px-4 border-0 fw-bold text-white h-50 py-3 h-75"
                  style={{ backgroundColor: "#E09552" }}
                  onClick={this.onclickApplyNow.bind(this)}
                >
                  Apply Now
                </button>
              </div>
              <div className="d-flex gap-5">
                <div className="col-lg-3">
                  <div className="col px-4 py-3 flex-column">
                    <div>
                      <p className="fw-bold m-0" style={{ color: `#303030` }}>
                        Date Posted:
                      </p>
                      <p style={{ color: `#30303080` }}>
                        {object?.created
                          ? moment(object?.created).format("MMMM D, YYYY")
                          : ""}
                      </p>
                    </div>
                    <div>
                      <p className="fw-bold m-0" style={{ color: `#303030` }}>
                        Deadline of Application:
                      </p>
                      <p style={{ color: `#30303080` }}>
                        {object?.deadline
                          ? moment(object?.deadline).format("MMMM D, YYYY")
                          : ""}
                      </p>
                    </div>
                    <div>
                      <p className="fw-bold m-0" style={{ color: `#303030` }}>
                        Slots available:
                      </p>
                      <p style={{ color: `#6D9E5F` }}>
                        {object?.slotVacancy} slots
                      </p>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column col-lg-7">
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex gap-3">
                      <div className="shadow-sm px-3 py-2 rounded-2 bg-white">
                        <i
                          className="bi bi-info-circle-fill fs-3"
                          style={{
                            color: `#D18237`,
                            width: `2rem`,
                          }}
                        ></i>
                      </div>
                      <p
                        className="fw-bold fs-5 align-self-center"
                        style={{ color: "#E09552" }}
                      >
                        Job Description
                      </p>
                    </div>
                    <div className="col-lg-10">
                      <p style={{ color: `#303030`, fontSize: `1.1rem` }}>
                        {object?.jobDescription
                          ?.split("\n")
                          .map((line, index) => (
                            <span key={index}>
                              {line}
                              <br />
                            </span>
                          ))}
                      </p>
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-3 mt-3">
                    <div className="d-flex gap-3">
                      <div className="shadow-sm px-3 py-2 rounded-2 bg-white">
                        <i
                          className="bi bi-briefcase-fill fs-3"
                          style={{
                            color: `#D18237`,
                            width: `2rem`,
                          }}
                        ></i>
                      </div>
                      <p
                        className="fw-bold fs-5 align-self-center"
                        style={{ color: "#E09552" }}
                      >
                        Qualification Standards
                      </p>
                    </div>
                    <div className="col-lg-10 fs-5">
                      <div
                        className="d-flex flex-column gap-2"
                        style={{ color: `#303030`, fontSize: `1.1rem` }}
                      >
                        <p style={{ color: `#303030`, fontSize: `1.1rem` }}>
                          {object?.qualificationStandard
                            ?.split("\n")
                            .map((line, index) => (
                              <span key={index}>
                                {line}
                                <br />
                              </span>
                            ))}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(JobDescription);
